import { type ReactNode } from 'react';
import { type Maybe } from '@models/Maybe';
import { type SeverityRating } from '@utils/cvss';
import { CvssSeverityIndicator } from '@components/cvss/cvss-severity-indicator/CvssSeverityIndicator';
import styles from './CveCvssSection.module.scss';

export interface CveCvssRadarMetricPillProps {
    label: string;
    value: string;
    rating: Maybe<SeverityRating>;
}

export function CveCvssRadarMetricPill({
    label,
    value,
    rating,
}: CveCvssRadarMetricPillProps): ReactNode {
    return (
        <span
            className={`${styles.radarMetricPill} inline-flex align-items-center gap-1 bg-white border-n40 px-2 py-1 white-space-nowrap`}
        >
            <span
                className={`${styles.radarMetricPillText} font-bold text-secondary uppercase`}
            >
                {label}:
            </span>
            <span
                className={`${styles.radarMetricPillText} font-bold text-primary`}
            >
                {value}
            </span>
            {rating ? <CvssSeverityIndicator rating={rating} square /> : null}
        </span>
    );
}
